import io from 'socket.io-client';
import {L} from "./util.js";
import TODO from "./TODO.js";
import {onpeerconnect,onpeerdisconnect,onreceiveoffer,
	onreceiveanswer,onicecandidate,on_mute_audio,
	on_mute_video,on_event_raise_hand,on_peername_change,
	on_peer_reconnect,on_screenshare,on_dimension,on_bandwidth} from "./main.js";

export const C2GSOCKET = (function() {

 class c2gsocket {
  /* { origin:, path:} */
  constructor(pp={}) {
   this.socket = io.connect(pp.origin||window.location.origin, {
    path: pp.path||'/c2go',
    'force new connection': false
   });
   this.socket
    .on('connect',this.on_connect.bind(this))
    .on('room',this.on_room.bind(this))
    .on('message',this.on_message.bind(this))
    .on('user',this.on_user.bind(this));
  }

  async name(name) {
   const rv = await this.emit('user','name',{name});
   if(!(rv && rv.S=='ok')) {
    L.error({rv},"error setting user name");
    throw new Error('error setting user name');
   }
   L.trace({name,rv},"name()");
   return rv;
  }

  // {room:,username:}
  async join(pp) {
   // TODO: username setting doesn't have much to do with `join`.
   L.trace({room:pp.room,username:pp.username},'-> socket:join');
   await this.name(pp.username);
   const rv = await this.emit('room','join',{room:pp.room});
   if(!(rv && rv.S=='ok')) {
    L.error({rv},"error joining the room");
    throw new Error('error joining the room');
   }
   return rv;
  }

  on_connect() {
   L.trace("<- socket:connect");
  }
  on_room(evt,d) {
   L.trace({evt,d},"<- socket:room");
   switch(evt) {
    case 'join': /* {room:,user:{id:,name:addr:}} */
     L.trace(d,"<- socket:room:join");
     onpeerconnect({un:d.user.name,uid:d.user.id});
     break;
    case 'leave': /* {room:,user:{id:,name:addr:}} */
     L.trace(d,"<- socket:room:leave");
     onpeerdisconnect({uid:d.user.id});
     break;
    default:
     L.warn({evt,d},"<- socket:room unknown message");
   }
  }
  on_message(evp,b) {
   L.trace({evp,body:b},"<- socket:message");
   if(TODO.selfId == evp.from.user.id) return;
   switch(evp.type) {
    case 'video-offer': /* {sdp:,muteInfo:{audio:,video:,hand:},name:,mdl:} */
     onreceiveoffer({ by:evp.from.user.id,name:evp.from.user.name,
                      mdl:b.mdl,muteInfo:b.muteInfo,sdp:b.sdp });
     break;
    case 'video-ice': /* {ice:} */
     onicecandidate({by:evp.from.user.id,ice:b.ice});
     break;
    case 'video-answer': /* {sdp:,muteInfo:{audio:,video:,hand:},name:,mdl:} */
     onreceiveanswer({ by:evp.from.user.id,name:evp.from.user.name,
                       mdl:b.mdl,sdp:b.sdp,muteInfo:b.muteInfo });
     break;
    case 'dimension': /* {x:,y:} */
     on_dimension({ by:evp.from.user.id,to:evp.to.user.id,
                    x:b.x, y:b.y });
     break;
    case 'hand': /* {raised:} */
     on_event_raise_hand({ by:evp.from.user.id, raised:b.raised });
     break;
    case 'audio': /* {muted:} */
     on_mute_audio({ by:evp.from.user.id, muted:b.muted });
     break;
    case 'video': /* {muted:} */
     on_mute_video({ by:evp.from.user.id, muted:b.muted });
     break;
    case 'screenshare': /* {is_on:} */
     on_screenshare({ by:evp.from.user.id, is_on:b.is_on });
     break;
    case 'peer.reconnect': /* TODO: this, probably should not exist */
     on_peer_reconnect({ by:evp.from.user.id });
     break;
    case 'bandwidth': /* {mdl:} */
     on_bandwidth({by:evp.from.user.id, mdl:b.mdl});
     break;
    default:
     L.warn({evp,body:b},`<- socket:message of unknown type ${evp.type}`);
     break;
   }
  }
  on_user(evt,d) {
   L.trace({evt,d},"<- socket:user");
   switch(evt) {
    case 'name': /* {user:{id:,name:,addr:}} */
     on_peername_change({by:d.user.id,value:d.user.name});
     break;
    default:
     L.warn({evt,d},`<- socket:user of unknown type ${evt}`);
     break;
   }
  }

  async emit(evn,...rest) {
   return new Promise((res/*TODO:,rej*/)=>{
    this.socket.emit(evn,...rest,res);
   });
  }
  async msg(evp,mb) {
   const rv = await this.emit('message',evp,mb);
   if(!(rv && rv.S=='ok')) {
    L.error({rv,evp,body:mb},'error sending message');
    throw new Error('error sending message');
   }
   L.trace({rv},"msg()");
   return rv;
  }

  async participants(pp) {
   const rv = await this.emit('room','participants',{room:pp.room});
   if(!(rv && rv.S=='ok')) {
    L.error({rv},"error listing participants");
    throw new Error("error listing participants");
   }
   L.trace({rv},"participants()");
   return rv.users. // TODO: remove legacy compatibility code below:
    map(x=>({un:x.name,uid:x.id}));
  }
 }

 return {
  c2gsocket: new c2gsocket()
 };

})();
